<template>
  <div class="settings q-gutter-y-lg row q-gutter-x-lg">
    <q-tabs
      vertical
      switch-indicator
      inline-label
      active-color="primary"
      :class="{ 'width-200': $q.screen.gt.xs }"
    >
      <q-route-tab
        :to="{ name: 'Profile' }"
        icon="person"
        :label="$q.screen.gt.xs ? 'Profile' : undefined"
        no-caps
        style="justify-content: left; padding-left: 16px"
      />
      <q-route-tab
        :to="{ name: 'Organization' }"
        icon="business"
        :label="$q.screen.gt.xs ? 'Organization' : undefined"
        no-caps
        style="justify-content: left; padding-left: 16px"
      >
      </q-route-tab>
      <q-route-tab
        v-if="isHelloDataEmployee"
        :to="{ name: 'Admin' }"
        icon="admin_panel_settings"
        :label="$q.screen.gt.xs ? 'Admin' : undefined"
        no-caps
        style="justify-content: left; padding-left: 16px"
      />
      <q-route-tab
        :disable="!hasBillingPortalUrl"
        :to="{ name: 'Billing' }"
        icon="account_balance"
        :label="$q.screen.gt.xs ? 'Billing' : undefined"
        no-caps
        style="justify-content: left; padding-left: 16px"
      />
      <q-route-tab
        href="https://www.hellodata.ai/learning-hub"
        target="_blank"
        icon="help"
        :label="$q.screen.gt.xs ? 'Help Center' : undefined"
        no-caps
        style="justify-content: left; padding-left: 16px"
      >
        <q-icon v-if="$q.screen.gt.xs" name="launch" class="q-ml-sm" />
      </q-route-tab>
      <div class="column q-ma-md">
        <a
          href="https://www.hellodata.ai/terms"
          target="_blank"
          style="text-decoration: none; color: inherit"
        >
          Terms
        </a>
        <a
          href="https://www.hellodata.ai/privacy-policy"
          target="_blank"
          style="text-decoration: none; color: inherit"
          :class="{ 'width-39': $q.screen.xs }"
        >
          Privacy Policy
        </a>
      </div>
    </q-tabs>
    <div class="col">
      <router-view />
    </div>
  </div>
</template>

<script lang="ts">
import { useStripeStore } from '@/stores/stripe'
import { useUserStore } from '@/stores/user'

export default {
  name: 'SettingsView',
  components: {},
  data() {
    return {
      hasBillingPortal: false
    }
  },
  computed: {
    products() {
      return this.$auth0.user.value?.products
    },
    organization() {
      return useUserStore().organization
    },
    isHelloDataEmployee() {
      return useUserStore().isHelloDataEmployee
    },
    hasBillingPortalUrl() {
      return useStripeStore().hasCustomerPortal
    }
  }
}
</script>
<style scoped>
.settings {
  max-width: 1280px;
  margin: auto;
}
.width-200 {
  width: 200px;
}
.width-39 {
  width: 39px;
}
</style>
